import { render, staticRenderFns } from "./DimensionFilterMenu.vue?vue&type=template&id=bac26fae&scoped=true"
import script from "./DimensionFilterMenu.vue?vue&type=script&lang=js"
export * from "./DimensionFilterMenu.vue?vue&type=script&lang=js"
import style0 from "./DimensionFilterMenu.vue?vue&type=style&index=0&id=bac26fae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bac26fae",
  null
  
)

export default component.exports